// Cliente de la campana de avisos in-app (NotificacionInterna). Cada usuario ve
// solo los suyos. Ver backend src/modules/avisos.
import { api } from './api';

export interface Aviso {
  id: string;
  tipo: string;
  titulo: string;
  mensaje: string;
  expediente_id?: string | null;
  radicado?: string | null;
  leida: boolean;
  fecha_creacion: string;
}

export interface AvisosResp {
  data: Aviso[];
  noLeidos: number;
}

export function listarAvisos(): Promise<AvisosResp> {
  return api<AvisosResp>('/avisos');
}
export function marcarAvisoLeido(id: string): Promise<unknown> {
  return api(`/avisos/${id}/leer`, { method: 'POST' });
}
export function marcarTodosLeidos(): Promise<unknown> {
  return api('/avisos/leer-todas', { method: 'POST' });
}
